export default "__VITE_ASSET__CyIrm0v2__"